'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeScattergeoIcon = function TraceTypeScattergeoIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#fff', d: 'M32.05 26.375l-2.3 3.45-4.6 1.15-2.3-2.3H19.4l-6.15 1.15-3.45-2.3 3.85-4.6v-3.45h5.163l4.187 3 4.45-3 9.2 6.9h-4.6z', strokeMiterlimit: '10' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#fff', d: 'M36.65 26.375l-9.2-6.9-4.45 3-4.187-3H13.65l-2.875-1.725v-2.3l-1.15-1.15-1.15 1.15-1.15-1.15V9.7h2.3l2.3-1.15h2.3l3.45 2.3h3.45l4.6-2.3 3.45 3.45-3.45 3.45h5.75v-2.3h3.45v1.15l1.15 1.15 1.15-1.15 3.45 3.45v3.45H36.65v5.175zm-9.775 7.475L25.725 35h-1.15l.575-4.025-2.3-2.3H19.4l-6.15 1.15 7.875 4.025v2.3l3.45 2.3h2.3l1.15-1.15V35l-1.15-1.15z', strokeMiterlimit: '10' }),
        _react2.default.createElement('circle', { cx: '37.5', cy: '18.5', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '23', cy: '18.5', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '11.5', cy: '12.5', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '16.5', cy: '22.5', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '14.5', cy: '26.5', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '26.5', cy: '25.5', r: '3', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '14.5', cy: '15.5', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '21.5', cy: '24.5', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '24.5', cy: '12.5', r: '1.5', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '31.5', cy: '18.5', r: '1', fill: '#1d9bfb' })
    );
};

exports.default = TraceTypeScattergeoIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeScattergeoIcon.js
// module id = 726
// module chunks = 0